import script from "./AdminLiensUtil.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLiensUtil.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLiensUtil.vue?vue&type=style&index=0&id=2b47bbe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b47bbe9"]])

export default __exports__